
export default function ConverterComparison() {
  const comparisonData = [
    {
      feature: '转换格式支持',
      traditional: '5-10 种',
      ours: '20+ 种'
    },
    {
      feature: '转换准确率',
      traditional: '85-90%',
      ours: '99.9%'
    },
    {
      feature: '批量处理',
      traditional: '有限支持',
      ours: '完全支持'
    },
    {
      feature: 'API 集成',
      traditional: '部分支持',
      ours: '完整 REST API'
    },
    {
      feature: '本地部署',
      traditional: '不支持',
      ours: '支持'
    },
    {
      feature: '技术支持',
      traditional: '工作时间',
      ours: '24/7 全天候'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            为什么选择我们
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            对比传统转换工具，我们提供更专业、更高效的解决方案
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid grid-cols-3 bg-gradient-to-r from-teal-600 to-cyan-600 text-white p-6">
              <div className="text-lg font-semibold">功能特性</div>
              <div className="text-lg font-semibold text-center">传统工具</div>
              <div className="text-lg font-semibold text-center">Adobe PDF Converter</div>
            </div>

            {comparisonData.map((item, index) => (
              <div
                key={index}
                className={`grid grid-cols-3 p-6 ${
                  index !== comparisonData.length - 1 ? 'border-b border-gray-200' : ''
                }`}
              >
                <div className="font-medium text-gray-900">{item.feature}</div>
                <div className="text-center text-gray-600">{item.traditional}</div>
                <div className="text-center">
                  <span className="inline-flex items-center px-3 py-1 bg-teal-50 text-teal-700 rounded-full font-semibold">
                    <i className="ri-check-line mr-1 w-4 h-4 flex items-center justify-center"></i>
                    {item.ours}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <a
              href="/contact"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-teal-600 to-cyan-600 text-white rounded-lg font-semibold hover:from-teal-700 hover:to-cyan-700 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-3-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              了解更多优势
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}